import React, { useEffect, useState } from 'react';
import { CancelButton, SubmitButton, UpdateButton } from '../../../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import { Box, Stack, TextField } from '@mui/material';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import GlobalSelectField from '../../../../../components/mui/GlobalSelectField';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { getAllBrands, updateBrand } from '../../../../../redux/features/assetManagementSlice';
import { EditButton } from '../../../../../components/mui/Buttons/Buttons';
import { updateCroNotes } from '../../../../../redux/features/CRDslice';

const Cronotes = ({ data, dispatchParams, courseEnrollmentId, crm, apiCall }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.crd);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cro_notes: data,
      course_enrollment_id: courseEnrollmentId,
    },
    onSubmit: (values) => {
      dispatch(updateCroNotes(values)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          setOpen(false);
          if (apiCall) {
            dispatch(apiCall(dispatchParams));
          }
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={'CRO Notes'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        <EditButton size="small" action={() => setOpen(true)} disabled={crm}>
          Add
        </EditButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                  <TextField
                    fullWidth
                    label="CRO Notes"
                    name="cro_notes"
                    multiline
                    rows={4}
                    value={formik.values.cro_notes}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.cro_notes && Boolean(formik.errors.cro_notes)}
                    helperText={formik.touched.cro_notes && formik.errors.cro_notes}
                  />
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? 'Please wait...' : 'Save'}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default Cronotes;
